import { apiSlice } from '../../api/apiSlice';
import { UsersListParams, UsersListResponse } from './usersListApiSliceTypes';

const usersListApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUsersList: builder.query<UsersListResponse, UsersListParams>({
            query: ({
                page,
                limit,
                sortBy,
                sortOrder,
                search,
                acceptLanguage,
                ...rest
            }) => {
                return {
                    url: '/users',
                    method: 'GET',
                    headers: {
                        'Accept-Language': acceptLanguage ?? 'en',
                    },
                    params: {
                        page,
                        limit,
                        sortBy,
                        sortOrder,
                        search,
                        ...rest,
                    },
                };
            },
            providesTags: [{ type: 'users', id: 'LIST' }],
        }),
    }),
    overrideExisting: true,
});

export const { useGetUsersListQuery, useLazyGetUsersListQuery } =
    usersListApiSlice;
